import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { USER_TIERS } from '../contexts/AuthContext';
import FamilySpace from '../features/family/FamilySpace';
import FamilyCalendar from '../features/family/FamilyCalendar';
import AuthRedirect from '../shared/AuthRedirect';
import ProtectedRoute from '../shared/ProtectedRoute';
import SubMenu from '../shared/SubMenu';
import { FAMILY_MENU_ITEMS } from '../config/menuConfig';

const FamilyRouter = () => {
  return (
    <>
      <SubMenu items={FAMILY_MENU_ITEMS} />
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <FamilySpace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/calendar"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <FamilyCalendar />
            </ProtectedRoute>
          }
        />
        {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
        <Route path="/profile" element={<AuthRedirect path="/profile" />} />
        <Route path="/login" element={<AuthRedirect path="/login" />} />
      </Routes>
    </>
  );
};

export default FamilyRouter;
